const ACTION = {
    UPDATE_REPAIR_ACCOUNT: 'UPDATE_REPAIR_ACCOUNT',
    UPDATE_REPAIR_METHOD_LIST: 'UPDATE_REPAIR_METHOD_LIST',
    UPDATE_COUNTRY_PROVINCE_LIST: 'UPDATE_COUNTRY_PROVINCE_LIST',
    UPDATE_PHONE_AREA_OPTIONS: 'UPDATE_PHONE_AREA_OPTIONS',
    UPDATE_DATEREVIEW_SHOW_MORE: 'UPDATE_DATEREVIEW_SHOW_MORE',
    UPDATE_IF_PAY_USER: 'UPDATE_IF_PAY_USER',
    UPDATE_HAS_STATUS: 'UPDATE_HAS_STATUS',
    UPDATE_ORIGINALUID: 'UPDATE_ORIGINALUID',
    UPDATE_GUIDE_INFO_ONCE_BIND_PHONE: 'UPDATE_GUIDE_INFO_ONCE_BIND_PHONE',
    UPDATE_GUIDE_INFO_CONTACT_PERSONS: 'UPDATE_GUIDE_INFO_CONTACT_PERSONS',
    UPDATE_BIND_PHONE: 'UPDATE_BIND_PHONE',
    UPDATE_IN_REPAIR: 'UPDATE_IN_REPAIR',
    UPDATE_SUBMIT_CLICK_COUNT: 'UPDATE_SUBMIT_CLICK_COUNT',
    UPDATE_VERIFY_PHONE_METHOD: 'UPDATE_VERIFY_PHONE_METHOD',
    UPDATE_EXTERNAL_VERIFY_LIST: 'UPDATE_EXTERNAL_VERIFY_LIST',
}

export default ACTION;
